module.exports = __webpack_public_path__ + "app-static/img/p_02.ee390e29.jpg";